import React, { Suspense } from 'react';
import { Button, Row, Col, Checkbox, Pagination } from 'antd';
// import { FilterProps } from '../Filter/FilterPc';
import styled from 'styled-components';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { FilterAll, FilterProps, FilterTypes } from '../FilterCommon/Filter';
import { DateDisabledHandler, DateLimitCalculator } from '@/utils/utils';
import { startTimeMax } from '../common/constant';
import dayjs from 'dayjs';
import { postMessageToParent, PostMessageType } from '../Report/utils/postMessageToParent';
import { useParams } from 'react-router-dom';
import aiLogo from '../../pages/customReport/images/aidata_button@2x.png';
// 导入AI报表服务
import { getAiReportConfig, AiReportInfo, ReportMenuItem } from '../Report/services/ai/aiReport';
import { getAiReportConfigCached } from '../Report/services/ai/aiReportCache';
import { convertSortParams  } from "../Report/share/params"
const FilterPcLazy = React.lazy(() => import('../Filter/FilterPc'));


const DhbFilterFormView = styled.div<{ $isAiChat?: boolean }>`
  &.dhb-filter-form{
    background-color: #fff;
    padding: ${props => props.$isAiChat ? '0px' : '16px 16px 6px 16px'};
  }
  .filter-actions{
    display:flex;
    justify-content:flex-end;
  }
  .search-reset-btn{
    width:60px;
    text-align:center;
    padding:0;
  }
  .link-text{
    display:flex;
    width:60px;
    height:30px;
    line-height:32px;
  }
  
`


interface DhbFilterFormProps<FP> {
  onReset?: (params: FP) => void;
  params?:FP
  onSearch(params: FP, notRunAsync?: boolean): void;
  defaultParams?: FP;
  filterProps: Pick<FilterProps, 'filters'|'rowFlex'>;
  loading?: boolean;
  isAiChat?: boolean; // 是否为AI报表
  isMainFilter?: boolean;// 是否为报表主搜索过滤框，如果不是，则表示商品对话框等界面的搜索过滤框
  externalTriggerAiSearch?: number; // 新增：外部触发AI搜索信号
}

export const DhbFilterForm = <FP extends {}>(props: DhbFilterFormProps<FP>) => {
  let defaultParams = { ...props.defaultParams } as FP;
  const [params, setParams] = React.useState<FP>({ ...defaultParams });
  const [showFilter, setShowFilter] = React.useState(false);
  
  // AI报表相关状态
  const [aiReportInfo, setAiReportInfo] = React.useState<AiReportInfo | null>(null);
  const [supportedReports, setSupportedReports] = React.useState<ReportMenuItem[]>([]);
  const [showAiButton, setShowAiButton] = React.useState(false);
  
  // 在组件内部获取报表名字
  const { reportName = '' } = useParams<{reportName: string}>();

  // 组件初始化时获取AI报表信息
  React.useEffect(() => {
    const initAiReportData = async () => {
      const { aiInfo, supportedReports, showAiButton } = await getAiReportConfigCached(reportName);
      setAiReportInfo(aiInfo);
      setSupportedReports(supportedReports);
      setShowAiButton(showAiButton);
    };
    
    if (reportName) {
      initAiReportData();
    }
  }, [reportName]);

  // AI报表模式下首次加载时自动执行搜索
  React.useEffect(() => {
    if (props.isAiChat && reportName) {
      onDifyDrawer(true);
    }
  }, [props.isAiChat, reportName, params]);

  const extraFilterList = React.useCallback((item:FilterAll)=>{

    if(item.type == FilterTypes.DatePick ){
      if(item.startDay && item.enabledStartDate){
        item.disabledDate =(current)=>{
          const limitDate = DateLimitCalculator.calculateLimitByUnit(item.enabledStartDate || '3y');
          
          if (current && limitDate && current.valueOf() < limitDate.valueOf()) {
              return true;
          }
          return false;
        }
      }
      if(item.endDay && item.enabledStartDate){
        item.disabledDate =(current)=>{
          const limitDate = DateLimitCalculator.calculateLimitByUnit(item.enabledStartDate || '3y');
          // 使用类型断言确保params中存在start_date属性
          const startDate = (params as any).start_date;
          if(startDate && current && current.valueOf() < dayjs(startDate).valueOf()){
            return true
          }
          if (current && limitDate && current.valueOf() < limitDate.valueOf()) {
              return true;
          }
          return false;
        }
      }
      if(item.endDay && item.enabledEndDate){
        item.disabledDate =(current)=>{
          // 计算限制日期的前一年的年末，例如'3y'表示3年前的年末
          const enabledEndDate = item.enabledEndDate;
          if (enabledEndDate) {
            let endLimitDate = DateDisabledHandler.calculateEndDateLimit(enabledEndDate);
            // 禁用endLimitDate之后的日期
            if (current && endLimitDate && current.valueOf() > endLimitDate.valueOf()) {
                return true;
            }
            return false

          }
          
          // 使用类型断言确保params中存在start_date属性
          const startDate = (params as any).start_date;
          if(startDate && current && current.valueOf() < dayjs(startDate).valueOf()){
            return true
          }
          return false;
        }
      }
    }
    if(item.type === FilterTypes.DateUnitPick){
      if(item.picker === 'year'){
        item.disabledDate =(current)=>{
          const minYear = dayjs( DateLimitCalculator.calculateLimitByUnit(startTimeMax)).year();
          const maxYear = new Date().getFullYear(); 
          const currentYear = current.year();
          return currentYear < minYear || currentYear > maxYear;
        }
      }
    }
  },[])
  // const [expandFilter, setExpandFilter] = React.useState(false)
  const onReset = () => {
    setParams({ ...defaultParams });
    props.onReset && props.onReset({ ...defaultParams });
  };
  // 转换参数发送到 AI CHAT 服务，然后需要会传到 AI Dify 的后端服务
  const transformSearchApiParams = (params: Record<string, any>): Record<string, any> => {
    const newParams = convertSortParams(params);
    const query = new URLSearchParams(Object.entries(newParams)).toString();

    const usp = new URLSearchParams(query);
    const queryObject: Record<string, any> = {};
    usp.forEach((value, key) => {
      const all = usp.getAll(key);
      queryObject[key] = all.length > 1 ? all : value;
    });

    return queryObject;
  };
  const onDifyDrawer = (isInitSearch:boolean = false) => {
    postMessageToParent({
      type: PostMessageType.openDifyAI,
      data: {
        isInitSearch,
        report: reportName, // 使用内部获取的报表名字
        searchParams: params, // 搜索参数
        searchApiParams: transformSearchApiParams(params), // 后端使用的参数，需要转换一次保持和data传参逻辑一致
        url: `${domainConfig.hosts['releated-dify-chat']}/app/1393f6c1-fc94-4ddd-95dc-ee7519a14ae4`, // 打开的url
      }
    });
  };

  const onSearch = (openDifyDrawer:boolean = false, notRunAsync:boolean = false) => {
    // AI报表直接拦截后端搜索请求，直接向上一层父级iframe传递消息
    if (props.isAiChat || openDifyDrawer) {
      onDifyDrawer(false)
    }

    props.onSearch({...params}, notRunAsync);
  };
  // 外部信号变化时，触发 AI 搜索（仅当值 > 0）
  React.useEffect(() => {
    if (props.externalTriggerAiSearch && props.externalTriggerAiSearch > 0) {
      onSearch(true, true)
    }
  }, [props.externalTriggerAiSearch]);
  // 外部参数发生变化，内部需要刷新界面
  React.useEffect(()=>{
    if(props.params){
      setParams(props.params)
    }
  },[props.params])

  const filtePropsCallback = ()=>{
    const filterList = props.filterProps.filters?.map(item=>{
      extraFilterList(item)
      return item
    })

    return {
        ...props.filterProps,
        filters:filterList
    }
  }
  // let filterLists = showFilter ? props.filterProps.filters : props.filterProps.filters.slice(0,7)

  return (
    <DhbFilterFormView className='dhb-filter-form' $isAiChat={props.isAiChat}>
      <Row>
        <Col span={props.isAiChat ? 24 : 21}>
          <Suspense fallback={'loading'}>
            <FilterPcLazy
              {
                ...filtePropsCallback()
              }
              isAiChat={props.isAiChat}
              showFilter={showFilter}
              onChangeValues={(dataIndex, value) => {
                setParams((params) => {
                  return { ...params, [dataIndex]: value };
                });
              }}
              values={params}
            />
          </Suspense>
        </Col>
        <Col span={props.isAiChat ? 24 : 3} className="filter-actions"  >
          {!props.isAiChat && props.isMainFilter && showAiButton && (
            <div
              onClick={() => onSearch(true)}
              style={{position:'absolute', top:'-60px', 'right': '10px', cursor: 'pointer'}}> 
              <img src={aiLogo} alt="AI" width={110} />
            </div>
          )}
          {!props.isAiChat && (
            <Button
              type="primary"
              onClick={() => onSearch()}
              loading={props.loading}
              className='search-reset-btn'
            >
              查询
            </Button>
          )}
          <Button onClick={onReset} className='search-reset-btn' disabled={props.loading}  style={{margin:'0 10px'}}>
            重置
          </Button>
          {props.filterProps.filters&&props.filterProps.filters.length>7?<a className='link-text' onClick={()=>{setShowFilter(isShow=>!isShow)}}><div style={{width:'34px'}}>{showFilter?'收起':'展开'}</div>{showFilter?<UpOutlined />:<DownOutlined /> }</a>:null}
        </Col>
      </Row>
    </DhbFilterFormView>
  );
};
export enum  ExportQuanlityType {
  'all' = 'all',
  "page" = 'page'
}

export interface DhbFooterProps {
  selectedRowKeys?: any[];
  dataSource?: any[];
  toggleSelectRowKeys?(): void;
  isAllSelect?: boolean;
  total: number;
  onExport?(key: ExportQuanlityType): void;
  onChange(pageInfo: { page: number; pageSize: number }): void;
  pageInfo: { page: number; pageSize: number };
}

export const DhbFooter = (props: DhbFooterProps) => {
  const {
    selectedRowKeys = [],
    onChange,
    dataSource = [],
    isAllSelect,
    total = 0,
    pageInfo,
    toggleSelectRowKeys,
  } = props;
  const { page = 1, pageSize = 10 } = pageInfo;

  return (
    <div style={{ padding: '10px' }}>
      <Row>
        <Col span={8}>
          <Checkbox
            style={{ marginLeft: '23px' }}
            checked={isAllSelect}
            // indeterminate={isAllSelect}
            onChange={toggleSelectRowKeys}
          />
        </Col>
        <Col span={16}>
          <Pagination
            style={{ textAlign: 'right' }}
            defaultPageSize={pageSize}
            total={total}
            current={page}
            onChange={(page, pageSize) => onChange({ page: page, pageSize })}
            onShowSizeChange={(current, pageSize) =>
              onChange({ page: 1, pageSize })
            }
            showQuickJumper={false}
          />
        </Col>
      </Row>
    </div>
  );
};
